import { toast } from "../ui/sonner";

/* 导出踏勘风险报告 PDF（后端同时存入项目文件「现场踏勘报告」），新窗口打开 + 触发下载 */
export const exportSurveyPdf = async (api, pid, zh, setBusy, lang) => {
  const L = lang || (zh ? "zh" : "en");
  setBusy?.(true);
  try {
    const res = await api.get(`/projects/${pid}/site-survey/report.pdf?lang=${L}`, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = url; a.download = L === "zh" ? `踏勘风险报告_${pid}.pdf` : L === "es" ? `InformeVisitaTecnica_${pid}.pdf` : `SiteSurveyReport_${pid}.pdf`; a.rel = "noopener";
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 30000);
    toast.success(zh ? "踏勘报告已生成并存入项目文件" : "Report exported & saved to project files");
    return true;
  } catch (e) {
    toast.error(e?.response?.data?.detail || (zh ? "导出失败" : "Export failed"));
    return false;
  } finally { setBusy?.(false); }
};
